import {
  createRouter,
  createWebHashHistory,
  createWebHistory
} from 'vue-router'

import VueCookies from 'vue-cookies'
import {
  Message,
} from 'view-ui-plus';

// 404页
import page_404 from '../views/sys/page_404.vue'

// 登录
import login_index from '../views/login/index.vue'
// 管理员登录
import admin_login from '../views/login/admin_login.vue'
// 钉钉登录
import login_dingding_h5 from '../views/login/dingding/h5_login.vue'

// 登录
import login_cut_sys from '../views/login/cut_sys.vue'
// 刷新登录
import refreshing_login from '../views/login/refreshing_login.vue'
// 微信公众号登录
import wxmp_login from '../views/login/wxmp_login.vue'
// 用户协议
import privacy_policy from '../views/login/xieyi/privacy_policy.vue'
// 隐私条款
import user_agreement from '../views/login/xieyi/user_agreement.vue'
// 用户协议
import privacy_policy_ios from '../views/login/xieyi/privacy_policy_ios.vue'
// 隐私条款
import user_agreement_ios from '../views/login/xieyi/user_agreement_ios.vue'

// 权限配置
// 系统列表 
import auth_manage_sys_sys_setting from '../views/auth_manage/sys/sys_setting.vue'
// 权限列表
import auth_manage_auth_auth_setting from '../views/auth_manage/auth/auth_setting.vue'
// 角色列表
import auth_manage_auth_role_setting from '../views/auth_manage/role/role_setting.vue'

// 用户管理
// 用户列表
import user_manage_user_list_index from '../views/user_manage/user_list/index.vue'
// 组织架构
import user_manage_framework from '../views/user_manage/framework/index.vue'
// 用户使用情况
import user_manage_usage_details from '../views/user_manage/usage_details/index.vue'


// API管理
// 密钥管理
import api_manage_ak_ak_setting from '../views/api_manage/ak/ak_setting.vue'
// 白名单ip
import api_manage_ak_white_ip from '../views/api_manage/white_ip/index.vue'
// 钉钉
import api_manage_dingtalk from '../views/api_manage/dingtalk/index.vue'

// APP管理
// 版本管理
import app_manage_version from '../views/app_manage/version.vue'
// ios版本
import app_manage_ios_version from '../views/app_manage/ios_version.vue'

// 消息管理
// 模板
import msg_manage_template from '../views/msg_manage/template.vue'

//官网管理
// 新闻
import ows_manage_news from '../views/ows_manage/news/index.vue'


// 用户
import user_index from '../views/user/index.vue'
// 用户v2
import user_index_v2 from '../views/user/index_v2.vue'
// 用户安全中心
import user_safe from '../views/user/safe/safe.vue'
// 修改密码
import user_change_pwd from '../views/user/safe/change_pwd.vue'
// 微信h5授权
import user_h5_wx_mp_auth from '../views/user/h5/wx_mp_auth.vue'


var page_title = '大象·统一认证中心'
const routes = [{

  path: '/:catchAll(.*)',
  component: page_404,
  meta: { title: page_title }
},
{

  path: '/page_404',
  component: page_404,
  meta: { title: page_title }
},
{
  path: '/',
  name: 'login_index',
  component: login_index,
  meta: { title: page_title }
},
{
  path: '/login/dingding_h5',
  name: 'login_dingding_h5',
  component: login_dingding_h5,
  meta: { title: '钉钉关联登录' }
},
{
  path: '/admin_login',
  name: 'admin_login',
  component: admin_login,
  meta: { title: '登录' }
},
{
  path: '/cut_sys',
  name: 'login_cut_sys',
  component: login_cut_sys,
  meta: { title: page_title }
},
{
  path: '/refreshing_login',
  name: 'refreshing_login',
  component: refreshing_login,
  meta: { title: page_title }
},
{
  path: '/wxmp_login',
  name: 'wxmp_login',
  component: wxmp_login,
  meta: { title: page_title }
},

{
  path: '/auth_manage/sys/sys_setting',
  name: 'auth_manage_sys_sys_setting',
  component: auth_manage_sys_sys_setting,
  meta: { title: '系统列表' }
},
{
  path: '/auth_manage/auth/auth_setting',
  name: 'auth_manage_auth_auth_setting',
  component: auth_manage_auth_auth_setting,
  meta: { title: '权限列表' }
},
{
  path: '/auth_manage/role/role_setting',
  name: 'auth_manage_auth_role_setting',
  component: auth_manage_auth_role_setting,
  meta: { title: '角色列表' }
},


{
  path: '/user_manage/user_list/index',
  name: 'user_manage_user_list_index',
  component: user_manage_user_list_index,
  meta: { title: '用户列表' }
},
{
  path: '/user_manage/framework',
  name: 'user_manage_framework',
  component: user_manage_framework,
  meta: { title: '组织架构' }
},
{
  path: '/user_manage/usage_details',
  name: 'user_manage_usage_details',
  component: user_manage_usage_details,
  meta: { title: '使用数据' }
},

{
  path: '/api_manage/ak/ak_setting',
  name: 'api_manage_ak_ak_setting',
  component: api_manage_ak_ak_setting,
  meta: { title: '密钥管理' }
},
{
  path: '/api_manage/ak/white_ip',
  name: 'api_manage_ak_white_ip',
  component: api_manage_ak_white_ip,
  meta: { title: 'ip白名单' }
},
{
  path: '/api_manage/ak/dingtalk',
  name: 'api_manage_dingtalk',
  component: api_manage_dingtalk,
  meta: { title: '日历' }
},


{
  path: '/app_manage/version',
  name: 'app_manage_version',
  component: app_manage_version,
  meta: { title: '安卓版本' }
},
{
  path: '/app_manage/ios_version',
  name: 'app_manage_ios_version',
  component: app_manage_ios_version,
  meta: { title: 'ios版本' }
},
{
  path: '/user/index',
  name: 'user_index',
  component: user_index,
  meta: { title: '个人中心' }
},
{
  path: '/user/safe',
  name: 'user_safe',
  component: user_safe,
  meta: { title: '安全中心' }
},
{
  path: '/user/index/v2',
  name: 'user_index_v2',
  component: user_index_v2,
  meta: { title: '大象·个人中心' }
},
{
  path: '/user/h5/wx_mp_auth',
  name: 'user_h5_wx_mp_auth',
  component: user_h5_wx_mp_auth,
  meta: { title: '绑定微信' }
},

{
  path: '/privacy_policy_ios',
  name: 'privacy_policy_ios',
  component: privacy_policy_ios,
  meta: { title: '隐私政策' }
},
{
  path: '/user_agreement_ios',
  name: 'user_agreement_ios',
  component: user_agreement_ios,
  meta: { title: '用户协议' }
},

{
  path: '/privacy_policy',
  name: 'privacy_policy',
  component: privacy_policy,
  meta: { title: '隐私政策' }
},
{
  path: '/user_agreement',
  name: 'user_agreement',
  component: user_agreement,
  meta: { title: '用户协议' }
},
{
  path: '/user/change_pwd',
  name: 'user_change_pwd',
  component: user_change_pwd,
  meta: { title: '修改密码' }
},

{
  path: '/msg_manage/template',
  name: 'msg_manage_template',
  component: msg_manage_template,
  meta: { title: '消息模板' }
},

{
  path: '/ows_manage/news',
  name: 'ows_manage_news',
  component: ows_manage_news,
  meta: { title: '新闻列表' }
},




]

const router = createRouter({
  history: createWebHistory(),
  routes
})



var pass_path = [
  '/',
  '/user_agreement',
  '/privacy_policy',
  '/user_agreement_ios',
  '/privacy_policy_ios',
  '/refreshing_login',
  '/wxmp_login',
  '/cut_sys',
  '/admin_login',
  '/login/dingding_h5',
  '/user/h5/wx_mp_auth'
]

var staff_path_list = ['/user/index', '/user/safe', '/user/index/v2', '/user/change_pwd'];

router.beforeEach((to, from, next) => {

  document.title = to.meta.title

  // 路径是这几个，不用登录，直接跳转
  if (pass_path.indexOf(to.path) !== -1) {
    next();
  } else {
    // 如果是用户登录页
    if (staff_path_list.indexOf(to.path) !== -1) {
      console.log('员工登录页');
      // 是员工登录页
      var dx_token = VueCookies.get('dx_token');
      if (dx_token) {
        console.log('dx_token------', dx_token);
        next();
      } else {
        console.log('dx_token222------', dx_token);
        next('/');
      }
    } else {
      // 管理员页面
      var admin_token = VueCookies.get('admin_token');
      if (admin_token) {
        next();
      } else {
        next('/');
      }
    }
  }
});


export default router